<template>
    <v-row align="center">
        <!-- <v-col class="pb-0" cols="3" sm="3" md="3">
            <span class="text-h6">Наименование теста:</span>
        </v-col>
        <v-col class="pb-0" cols="9" sm="9" md="9">
            <v-text-field v-if="!load" label="Наименование теста" outlined hide-details />
            <v-skeleton-loader  v-if="load" type="heading" />
        </v-col>
        
        <v-col class="pb-0" cols="3" sm="3" md="3">
            <span class="text-h6">Система организма:</span>
        </v-col>
        <v-col class="pb-0" cols="9" sm="9" md="9">
            <v-text-field v-if="!load" label="Наименование теста" outlined hide-details />
            <v-skeleton-loader  v-if="load" type="heading" />
        </v-col> -->
        
        <v-col class="pb-0" cols="12" sm="4" md="3">
            <span class="text-h6">Дата прохождения:</span>
        </v-col>
        <v-col class="pb-0" cols="12" sm="8" md="9">
            <v-select @change="chengeDate" return-object :items="listResults" item-text="date" item-value="id" v-model="selectedTest" outlined hide-details />
            <v-skeleton-loader class="date-btn" v-if="load" type="button" />
        </v-col>
        
        <v-col cols="12" sm="4" md="3">
            <span class="text-h6">Процент прохождения:</span>
        </v-col>
        <v-col cols="12" sm="8" md="9">
            <span class="text-subtitle-1">{{ score }}%</span>
            <v-skeleton-loader  v-if="load" type="button" />
        </v-col>

        <v-col cols="12" sm="12" md="12">
            <v-divider />
        </v-col>

        <v-col cols="12" sm="12" md="12" v-if="!load">
            <div v-for="(item, key) in questions" :key="'A'+key">
                <span class="text-h6">
                    {{ key + 1 }}. {{ item.title }} ?
                </span>
                
                <media-files v-if="item.files.length > 0" :files="item.files" />
                <!-- questionType = 0 -->
                <div class="py-4" v-if="item.questionType === 0">
                    <v-radio-group column v-model="radio">
                        <v-radio
                            v-for="(it, key) in item.answers"
                            :key="it.id"
                            :class="{ 'pb-2': key !== item.answers.length-1 }"
                            :color="it.correct || it.selected ? 'grey' : ''"
                            :value="it.selected"
                            readonly
                        >
                            <template v-slot:label>
                                <span :class="{ 'successText': it.correct }">{{ it.title }}</span>
                                <v-icon :color="it.correct ? 'green' : 'red'" v-if="it.selected" class="ml-2">mdi-check-all</v-icon>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </div>

                <!-- questionType = 1 -->
                <div class="py-4" v-if="item.questionType === 1">
                    <v-checkbox
                        v-for="it in item.answers"
                        :key="it.id"
                        readonly
                        :color="it.correct || it.selected ? 'grey' : ''"
                        v-model="it.selected"
                    >
                        <template v-slot:label>
                            <span :class="{ 'successText': it.correct }">{{ it.title }}</span>
                            <v-icon :color="it.correct ? 'green' : 'red'" v-if="it.selected" class="ml-2">mdi-check-all</v-icon>
                        </template>
                    </v-checkbox>
                </div>

                <!-- questionType = 2 -->
                <div class="py-4" v-if="item.questionType === 2">
                    <div
                        v-for="it in item.terms"
                        :key="it.id"
                    >
                        <v-row>
                            <v-col cols="12" sm="5" md="4">
                                <span class="v-label">{{ it.title }}</span>
                            </v-col>
                            <v-col cols="10" sm="5" md="7">
                                <v-select
                                    outlined
                                    dense
                                    readonly
                                    hide-details
                                    item-text="title"
                                    item-value="id"
                                    return-object
                                    v-model="it.selected"
                                    :items="item.termAnswers"
                                    label=""
                                    :color="it.correct ? 'green' : 'red'"
                                    :item-color="it.correct ? 'green' : 'red'"
                                >
                                    <template v-slot:selection="{ item }">
                                        <span class="successText">{{item.title}}</span>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="2" sm="2" md="1">
                                <v-icon :color="it.correct ? 'green' : 'red'" class="ml-2">mdi-check-all</v-icon>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
        </v-col>
        
        <v-col cols="12" sm="12" md="12" v-if="load">
            <div v-for="item in 4" :key="'B'+item">
                <v-skeleton-loader type="article" />
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import mediaFiles from '../../../../components/TaskMediaFiles.vue'
import { mapActions } from 'vuex'

export default {
    components: { mediaFiles },
    props: {
        apiUrl: { type: String },
        idTest: { type: String }
    },
    computed: {
        ...mapGetters({
            userInfo: 'user/userInfo'
        })
    },
    data: () => ({
        radio: true,
        load: true,
        listResults: [],
        questions: [],
        selectedTest: null,
        score: null
    }),
    methods: {
        ...mapActions({
            randomGenerate: 'tests/randomGenerate'
        }),
        chengeDate(obj) {
            this.load = true;
            this.getResult(obj.id);
        },
        getResultsAll() {
            this.$http.get(`${this.apiUrl}TestTask/GetResults?testId=${this.idTest}&userId=${this.userInfo.id}`)
            .then((res) => {
                for (let i = 0; i < res.data.length; i++) {
                    res.data[i].date = new Date(res.data[i].created).toLocaleString();
                }
                this.listResults = res.data
                this.selectedTest = res.data[0].id;
                this.getResult(res.data[0].id);
            })
        },
        getResult(id) {
            this.$http.get(`${this.apiUrl}TestTask/GetResult?id=${id}`)
            .then((res2) => {
                for (let i = 0; i < res2.data.questions.length; i++) {
                    if(res2.data.questions[i].questionType == 0 || res2.data.questions[i].questionType == 1) {
                        for (let j = 0; j < res2.data.questions[i].answers.length; j++) {
                            for (let k = 0; k < res2.data.questions[i].selectedAnswers.length; k++) {
                                if(res2.data.questions[i].answers[j].id === res2.data.questions[i].selectedAnswers[k].id) {
                                    res2.data.questions[i].answers[j].selected = true;
                                }
                            }
                        }
                    }

                    if(res2.data.questions[i].questionType == 2) {
                        for (let j = 0; j < res2.data.questions[i].terms.length; j++) {
                            for (let k = 0; k < res2.data.questions[i].termAnswers.length; k++) {
                                if(res2.data.questions[i].terms[j].id === res2.data.questions[i].termAnswers[k].testQuestionTermId) {
                                    res2.data.questions[i].terms[j].selected = res2.data.questions[i].termAnswers[k];
                                }
                            }
                            
                            for (let k = 0; k < res2.data.questions[i].termAnswers.length; k++) {
                                if(res2.data.questions[i].terms[j].id === res2.data.questions[i].selectedTermAnswers[k].testQuestionTermId) {
                                    res2.data.questions[i].terms[j].correct = true;
                                } else {
                                    res2.data.questions[i].terms[j].correct = false;
                                }
                            }
                        }
                    }
                }
                this.score = res2.data.score;
                this.questions = res2.data.questions;
                this.load = false;
            })
        }
    },
    created() {
        this.getResultsAll();
    }
}
</script>

<style>
.date-btn .v-skeleton-loader__button {
    width: 260px;
}
.successText {
    color: #4caf50;
}
</style>